import Group from "../group/Group";
import Person from "../person/Person";

export default class ParticipantGroupRegistrationRequest {
    id: number;
    personId: number;
    groupId: number;
    isDisabled: boolean;
    isLeader: boolean;
    isAdmin: boolean;
    isAssociationAdmin: boolean;

    person?: Person;
    group?: Group;

    constructor(
        id: number,
        personId: number,
        groupId: number,
        isDisabled: boolean,
        isLeader: boolean,
        isAdmin: boolean,
        isAssociationAdmin: boolean,
    ) {
        this.id = id;
        this.personId = personId;
        this.groupId = groupId;
        this.isDisabled = isDisabled;
        this.isLeader = isLeader;
        this.isAdmin = isAdmin;
        this.isAssociationAdmin = isAssociationAdmin;
    }
}